import { useGetList } from 'react-admin';

import type { UserCallRecordingConf } from '@ragu-components/ord-types';

interface UseUserRecordingConfsDataReturn {
  assignments: UserCallRecordingConf[];
  /** userId → assignment ID, for diffing additions/removals */
  userAssignmentMap: Map<string, string>;
  assignedUserIds: string[];
  loaded: boolean;
}

export const useUserRecordingConfsData = (confId: string): UseUserRecordingConfsDataReturn => {
  const resource = `call_recording_confs/${confId}/user_call_recording_confs`;
  const { data: assignments } = useGetList<UserCallRecordingConf>(resource, {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: 'type', order: 'ASC' },
  });

  const userAssignmentMap = new Map<string, string>();
  const assignedUserIds: string[] = [];

  if (assignments !== undefined) {
    for (const assignment of assignments) {
      userAssignmentMap.set(assignment.user.id, assignment.id);
      assignedUserIds.push(assignment.user.id);
    }
  }

  return {
    assignments: assignments ?? [],
    userAssignmentMap,
    assignedUserIds,
    loaded: assignments !== undefined,
  };
};
